"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const HeaderSkeleton = ({
  animation = 'pulse',
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.HEADER_SKELETON),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TitleSkeleton, {
      variant: "rectangular",
      animation: animation
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubtitleSkeleton, {
      variant: "rectangular",
      animation: animation
    })]
  });
};
exports.HeaderSkeleton = HeaderSkeleton;
